import { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { formatTimeMinutes } from "utils";

export default function SpeakerAttributionModal({ loading }) {
  const COUNTDOWN = 270;
  const [etaSeconds, setEtaSeconds] = useState(COUNTDOWN);
  const [showReloadOption, setShowReloadOption] = useState(false);

  useEffect(() => {
    if (!loading) {
      setEtaSeconds(COUNTDOWN);
      return;
    }

    const interval = setInterval(() => {
      setEtaSeconds((prev) => {
        if (prev <= 1) return 0;
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [loading]);

  useEffect(() => {
    let interval;

    if (etaSeconds === 0 && loading) {
      interval = setInterval(() => {
        setShowReloadOption(true);
      }, 60 * 1000);
    }

    return () => {
      clearInterval(interval);
    }
  }, [etaSeconds, loading]);

  return (
    <Dialog
      open={loading}
      keepMounted
      PaperProps={{
        sx: {
          margin: 0,
          width: "90vw",
          maxWidth: 540,
          borderRadius: "28px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "32px",
        },
      }}
    >
      <Box
        sx={{
          boxSizing: "border-box",
          width: "100%",
          height: 224,
          border: "1px solid #D0D5DC",
          boxShadow: "0px 10px 40px rgba(0, 0, 0, 0.03)",
          borderRadius: "22px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          justifyContent: "center",
          mb: "32px",
        }}
      >
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: "72px",
            lineHeight: 1.25,
            letterSpacing: "-2.94px",
            mb: "16px",
          }}
        >
          {formatTimeMinutes(etaSeconds)}
        </Typography>

        <Box
          sx={{
            background: "linear-gradient(180deg, #F5F5F7 0%, #E8E8ED 100%)",
            borderRadius: 99,
            padding: "6px 16px",
          }}
        >
          <Typography sx={{ fontSize: "13px", color: "#667085" }}>
            mins remaining
          </Typography>
        </Box>

        {etaSeconds === 0 && !showReloadOption && (
          <Typography sx={{ fontSize: "13px", color: "#667085", mt: "12px" }}>
            Speaker Attribution Check is taking a little longer than expected...
          </Typography>
        )}

        {showReloadOption && (
          <Box sx={{ mt: "12px", mb: "12px", bgcolor: "#E8E8ED", p: "8px 16px", borderRadius: "8px" }}>
            <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "rgba(0, 0, 0, 0.87)" }}>
              Would you like to reload the page?
            </Typography>

            <Button variant="text" size="small" onClick={() => window.location.reload()}>
              Reload
            </Button>
          </Box>
        )}
      </Box>

      <Typography sx={{ fontSize: "20px", textAlign: "center", mb: "8px" }}>
        Speaker Attribution Check In Progress...
      </Typography>

      <Typography
        sx={{
          fontWeight: 400,
          fontSize: "14px",
          textAlign: "center",
          color: "#717171",
          maxWidth: 320,
          mb: "24px",
        }}
      >
        Our AI is analyzing your transcript for speaker attribution errors
      </Typography>

      <Box
        component="img"
        src="/img/inflxd-loading.gif"
        alt="loading..."
        sx={{ width: 36, height: 36, mx: "auto" }}
      />
    </Dialog>
  );
}
